module.exports = __webpack_public_path__ + "img/stock_bg.3bce0741.png";